<div
  class="colors-menu"
  [ngClass]="{ 'activated-color-box': menuTrigger.menuOpen }"
>
  <div
    class="colors-menu-blocker"
    *ngIf="!(stateManagerProjectService.isViewerLoaded$ | async)"
  ></div>
  <mat-icon
    class="colors-menu-corner"
    svgIcon="corner"
    (click)="menuTrigger.openMenu()"
    [ngClass]="{
      'activated-color-menu': menuTrigger.menuOpen,
      'disabled-color-menu': (isDisabledColorMenu$ | async)
    }"
  ></mat-icon>
  <div
    *ngFor="
      let color of colorsData[
        [ViewWindowIndex.Empty, ViewWindowIndex.Model3D].includes(
          stateManagerProjectService.currentSelectedWindow
        )
          ? 'viewer1'
          : 'viewer' + stateManagerProjectService.currentSelectedWindow
      ]
    "
    class="color-box"
    [ngStyle]="{ background: color.color }"
    [ngClass]="{
      'activated-box':
        stateManagerProjectService.currentActiveColor === color.indexOfSegment
    }"
    (click)="selectColor(color.indexOfSegment)"
  ></div>
  <div
    class="calibrate-button"
    (click)="menuTrigger.openMenu()"
    [ngClass]="{
      'activated-color-menu': menuTrigger.menuOpen,
      'disabled-color-menu': (isDisabledColorMenu$ | async)
    }"
  >
    <mat-icon [svgIcon]="'calibrate'"></mat-icon>
  </div>
</div>

<span
  #menuTrigger="matMenuTrigger"
  class="hidden-menu-trigger"
  [matMenuTriggerFor]="colorsPanelMenu"
>
</span>
<mat-menu
  #colorsPanelMenu
  xPosition="before"
  yPosition="below"
  class="colors-base-menu"
>
  <div
    class="color-menu-item"
    *ngFor="
      let color of colorsData[
        [ViewWindowIndex.Empty, ViewWindowIndex.Model3D].includes(
          stateManagerProjectService.currentSelectedWindow
        )
          ? 'viewer1'
          : 'viewer' + stateManagerProjectService.currentSelectedWindow
      ];
      let i = index
    "
    (click)="$event.stopPropagation()"
  >
    <mat-icon
      [svgIcon]="color.state ? 'show' : 'hide'"
      (click)="hideSegmentationLayer(color, i, $event)"
    ></mat-icon>
    <div
      class="color-menu-box not-touchable"
      [ngStyle]="{ background: color.color }"
      (click)="selectColor(color.indexOfSegment)"
    ></div>
    <span class="font-16"> {{ getColorName(color.indexOfSegment) }} </span>
  </div>
</mat-menu>
